export class DisableGarantiaRequest {
  public id_Garantia!: number
}
